var _ellipse, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEnvironmentalProfileActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 10.4804,
    cy: 5.24998,
    rx: 2.92182,
    ry: 3.49998,
    stroke: "#20E290",
    strokeWidth: 0.857143,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.28961 7.31301C5.91028 7.84875 5.29398 8.16728 4.63677 8.16728C3.97956 8.16728 3.36327 7.84875 2.98394 7.31301C2.07111 6.08907 2.07111 4.4122 2.98394 3.18825C3.36327 2.65252 3.97956 2.33398 4.63677 2.33398C5.29398 2.33398 5.91028 2.65252 6.28961 3.18825",
    stroke: "#20E290",
    strokeWidth: 0.857143,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.63691 10.5006V5.83398",
    stroke: "#20E290",
    strokeWidth: 0.857143,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4807 10.5V5.25",
    stroke: "#20E290",
    strokeWidth: 0.857143,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8179 10.5006H2.29932",
    stroke: "#20E290",
    strokeWidth: 0.857143,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.2666 12.2506H7.85097",
    stroke: "#20E290",
    strokeWidth: 0.857143,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M9.74121 12.2506H10.3256",
    stroke: "#20E290",
    strokeWidth: 0.857143,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2334 12.2506H12.8178",
    stroke: "#20E290",
    strokeWidth: 0.857143,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M2.29932 12.2506H2.88368",
    stroke: "#20E290",
    strokeWidth: 0.857143,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M4.7915 12.2506H5.37587",
    stroke: "#20E290",
    strokeWidth: 0.857143,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnvironmentalProfileActive);
export default __webpack_public_path__ + "static/media/environmental_profile_active.1d2b98fe7456cbda5546188620367cc0.svg";
export { ForwardRef as ReactComponent };